var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudyTabsDirectLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75.000000pt",
    height: "77.000000pt",
    viewBox: "0 0 75.000000 77.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,77.000000) scale(0.100000,-0.100000)",
    fill: "#677283",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 728 c-37 -18 -44 -51 -44 -213 l0 -155 30 0 29 0 3 158 3 157 285 0 285 0 0 -285 0 -285 -157 -3 -158 -3 0 -29 0 -30 155 0 c165 0 196 7 214 47 15 33 15 573 0 606 -6 14 -22 30 -36 36 -32 14 -579 14 -609 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 550 l0 -30 70 0 70 0 0 30 0 30 -70 0 -70 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 550 l0 -30 70 0 70 0 0 30 0 30 -70 0 -70 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 390 l0 -30 70 0 70 0 0 30 0 30 -70 0 -70 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 390 l0 -30 70 0 70 0 0 30 0 30 -70 0 -70 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 230 c0 -29 2 -30 44 -30 25 0 48 -5 52 -11 3 -6 -18 -35 -47 -65 -50 -51 -52 -55 -36 -71 16 -16 20 -14 71 36 30 29 59 50 65 47 6 -4 11 -27 11 -52 0 -42 1 -44 30 -44 l30 0 0 110 0 110 -110 0 -110 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 230 l0 -30 70 0 70 0 0 30 0 30 -70 0 -70 0 0 -30z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyTabsDirectLink);
export default __webpack_public_path__ + "static/media/StudyTabsDirectLink.2d66cc9b8a756ba7264cebb235fc6863.svg";
export { ForwardRef as ReactComponent };